import {
  NpssPostTemplatesQuery,
  NpssPostTemplatesQueryVariables,
} from '@amzn/ring-neighbors-api-orchestrator-gql-schema';
import GET_NPSS_POST_TEMPLATES from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/npss/npssPostTemplates.graphql';
import { useQuery } from '@apollo/client';

export const useNpssPostTemplates = (
  tags: string | string[] | undefined,
  title: string | undefined,
) =>
  useQuery<NpssPostTemplatesQuery, NpssPostTemplatesQueryVariables>(
    GET_NPSS_POST_TEMPLATES,
    {
      variables: {
        tags: tags,
        title: title,
      },
    },
  );
